import type React from "react"

import type { HttpErrorRecord } from "@/utils/api"

import type { ErrorDialogCsvUploadContentProps } from "./error-dialog-csv-upload-content.types"

export const ErrorDialogCsvUploadContent: React.FC<
  ErrorDialogCsvUploadContentProps
> = ({ error }) => {
  if (
    Array.isArray(error?.errors) &&
    error.errors.length &&
    error.errors[0].detail
  ) {
    return (
      <ul>
        {error.errors.map((record) => {
          const typedRecord = record as unknown as HttpErrorRecord

          return (
            <li key={`${typedRecord.status}-${typedRecord.detail}`}>
              {typedRecord.detail}
            </li>
          )
        })}
      </ul>
    )
  }

  return null
}
